import {NgModule} from '@angular/core';

// Models
export {User, PaginatedUsers} from './models/User'
export {SocialUser} from './models/SocialUser'
export {
  Store, PaginatedStores, WalletDetails, PayoutDetails, PaginatedAuditLog, PaginatedRevisions, Policy
} from './models/Store'
export {AdminDashboard} from './models/AdminDashboard';
export {Order, OrderItems, PaginatedOrders} from './models/Order';
export {Categories, PaginatedCategories, DynamicField} from './models/Categories';
export {Product, PaginatedProducts} from './models/Product';
export {Colors} from './models/Colors';
export {Contact, PaginatedContacts} from './models/Contact';
export {Materials} from './models/Materials';
export {Address} from './models/Address';
export {Notifications} from './models/Notifications';
export {CustomPackages} from './models/CustomPackages';
export {PaginatedSellers} from './models/Sellers';
export {PaginatedLogNotes} from './models/LogNote';
export {CompanyProfile, CompanyAlbum, ProductCapacity, QualityManagement} from './models/CompanyProfile';
export {CurrencyData} from './models/CurrencyData';
export {AdsAudience, Ads, PaginatedAds} from './models/Ads';
export {PromoCode, PaginatedPromoCode} from './models/PromoCode';
export {GiftCard, PaginatedGiftCard} from './models/GiftCard';
export {EmailTemplate, PaginatedEmailTemplate} from './models/EmailTemplate';
export {PaginatedAffiliateUsers} from './models/AffiliateUser';
export {EmailGroup, PaginatedEmailGroup} from './models/EmailGroup';
export {SubscriptionPlan, PaginatedSubscriptionPlan} from './models/SubscriptionPlan';
export {EmailQueue, PaginatedEmailQueue} from './models/EmailQueue';
export {PaginatedCron, Cron} from './models/Crons';
export {PaginatedNegotiation, Negotiation} from './models/Negotiation';
export {PaginatedStaff, Staff} from './models/Staff';
export {Messages} from './models/Messages';

// Constants
export {
  OrderStatusText, OrderStatus, ReturnOrderStatus, ReturnOrderStatusText
} from "./consts/OrderStatus";
export {ProfileStatus, ProfileStatusText} from "./consts/ProfileStatus";
export {countryCurrency, countryStates} from "./consts/CountryCurrency";
export {countryCodes, countriesWithAreaCodes} from "./consts/CountryCodes";
export {defaultFilters} from "./consts/DefaultFilters";
export {currencyISOCodes} from "./consts/CurrencyISOCodes";
export {measurementsList} from "./consts/MeasurementsList";
export {BusinessType} from "./consts/Company";
export {ProductsOf} from "./consts/HomeDetails";
export {ProductType} from "./consts/HomeDetails";
export {allowedCurrency, currenciesWithSymbol} from "./consts/AllowedCurrency";
export {googleCategoryId} from "./consts/GoogleCategoryId";

// Common functions
export {generateCategoryTree, generateCategoryChilds} from "./utils/CommonFunction";

@NgModule({
  imports: [],
})
export class DataModelsModule {
}
